import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Coordinates the mobile/tablet sidebar drawer between the navbar's
 * hamburger toggle and the sidebar itself - they're siblings under
 * AppComponent, not parent/child, so state can't be passed via
 * @Input/@Output and has to go through a shared service instead.
 */
@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private readonly isOpenSubject = new BehaviorSubject<boolean>(false);
  readonly isOpen$ = this.isOpenSubject.asObservable();

  toggle(): void {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }

  open(): void {
    this.isOpenSubject.next(true);
  }

  close(): void {
    this.isOpenSubject.next(false);
  }
}
